'use client';

import HeaderModal from '@/components/ui/modal/HeaderModal';
import NotificationContent from "@/featured/apps/components/notification/NotificationContent";
import { Drawer } from 'vaul';

interface NotificationMobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function NotificationMobileMenu({ isOpen, onClose }: NotificationMobileMenuProps) {
  if (!isOpen) return null;

  return (
    <Drawer.Root open={isOpen} onOpenChange={(open) => !open && onClose()} modal={false}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/40 dark:bg-black/60 z-[9990]" />
        <Drawer.Content
          className="fixed bottom-0 left-0 right-0 top-0 z-[9999] flex h-full max-h-[100dvh] flex-col bg-white dark:bg-gray-900 focus:outline-none"
        >
          {/* Drawer handle */}
          <div className="pt-2.5 pb-1 bg-white dark:bg-gray-800 shrink-0">
            <div className="mx-auto h-1.5 w-12 rounded-full bg-gray-300 dark:bg-gray-600" />
          </div>
          <div className="shrink-0">
            <HeaderModal
              title="Notification"
              onClose={() => onClose()}
            />
          </div>
          <div className="flex-1 overflow-y-auto bg-white dark:bg-gray-900 p-0 pb-[80px] flex flex-col">
            <NotificationContent />
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
